import { render, staticRenderFns } from "./BookingSummaryList.vue?vue&type=template&id=486abb48&scoped=true&"
import script from "./BookingSummaryList.vue?vue&type=script&lang=js&"
export * from "./BookingSummaryList.vue?vue&type=script&lang=js&"
import style0 from "./BookingSummaryList.vue?vue&type=style&index=0&id=486abb48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486abb48",
  null
  
)

export default component.exports